// Opt-out header for the apps' global error middleware: a request carrying it handles its own
// errors (e.g. shows an inline form error) instead of triggering the global error toast.
// Defined once here; both apps' errorMiddleware re-export it so shared client-file code can set it
// without importing an app-local module.
export const HANDLE_ERROR_LOCALLY_HEADER = "X-Handle-Error-Locally";

/**
 * Shape of an init override the generated api-clients accept: it receives the request the client
 * built and returns what to merge into it. Restated here because shared code cannot import a
 * generated client; structurally compatible with both apps' `InitOverrideFunction`.
 */
export type ApiInitOverride = (requestContext: { init: { headers?: Record<string, string> } }) => Promise<RequestInit>;

/**
 * Opts a request out of the global error toast while KEEPING the headers the client built. Passing
 * `{ headers: ... }` as a plain object instead would replace them entirely — dropping
 * `Content-Type: application/json` on a request with a JSON body — because the generated client
 * shallow-merges init overrides.
 */
export const withLocalErrorHandling: ApiInitOverride = ({ init }) =>
  Promise.resolve({ headers: { ...init.headers, [HANDLE_ERROR_LOCALLY_HEADER]: "true" } });
